// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".hero-image[data-v-30c3694d]{height:calc(100vh - 64px)}.text-shadow[data-v-30c3694d]{text-shadow:0 1px 3px rgba(0,0,0,.65)}.photographer-credit[data-v-30c3694d]{bottom:12px;position:absolute;right:24px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
